import { useState, useEffect } from "react";
import { getHashValue } from "utils/getQueryValue";
import ShelfForm from "./ShelfForm";
import { Button } from "components/core/basic/Button";
import { Modal } from "../../core/basic/RACModal";
import { css } from "../../../../styled-system/css";

const ShelfModal = (props) => {
  const autoShow = getHashValue("new_shelf", "false");
  const autoKeyword = getHashValue("keyword");
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (autoShow.toLowerCase() === "true" && props.numOfShelfCredits > 0 && props.numOfShelves > 0) {
      setShow(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.numOfShelfCredits, props.numOfShelves]);

  return (
    <>
      <Modal
        isOpen={show}
        onOpenChange={setShow}
        title={props.numOfShelves >= props.numOfShelfCredits ? "Subscription Limit Reached" : "Create a New Shelf"}
        className={props.numOfShelves >= props.numOfShelfCredits ? css({ width: "60vw" }) : css({ width: "90vw" })}
      >
        {props.loading ?
          "Loading..."
        : <ShelfForm
            create
            closeModal={() => {
              setShow(false);
            }}
            data={props.data}
            brandData={props.brandData}
            categoryFilter={props.categoryFilter}
            updateShelfData={props.updateShelfData}
            numOfShelfCredits={props.numOfShelfCredits}
            numOfShelves={props.numOfShelves}
            fullLayout
            modalForm={true}
            setCategoryFilter={props.setCategoryFilter}
            autoKeyword={autoKeyword}
          />
        }
      </Modal>
      <Button
        onPress={() => {
          setShow(true);
        }}
      >
        Create a New Shelf
      </Button>
    </>
  );
};

export default ShelfModal;
